import * as React from "react";
import Box from "@mui/material/Box";
import { Chip } from "@mui/material";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import NativeSelect from "@mui/material/NativeSelect";
import OutlinedInput from "@mui/material/OutlinedInput";
import { styled } from "@mui/system";

import classes from "./MUISelect.module.css";
import { LinearProgress } from "@mui/material";

const CustomFormControl = styled(FormControl)({
  "& .MuiNativeSelect-select": {
    borderRadius: 4,
    padding: 9,
    fontSize: 14,
  },
});

const MUINativeSelect = React.forwardRef(function MUINativeSelect(
  {
    label,
    options,
    placeholder = "Select",
    optionValue,
    defaultValue = "",
    onChange = () => { },
    loading,
    CustomOption,
    disabled = false,
    ...props
  },
  ref
) {
  const [value, setValue] = React.useState(null);

  React.useImperativeHandle(ref, () => {
    return {
      getValue: () => value,
    };
  });

  const isReadOnly = disabled;

  const renderReadOnlyValue = () => {
   if (!optionValue) {
    return (
      <Box sx={{ minHeight: '28px', display: 'flex', alignItems: 'center' }}>
        <span style={{ color: '#9ca3af', fontStyle: 'italic' }}>{placeholder}</span>
      </Box>
    );
  }
    const selectedOption = options.find(opt => opt.value === optionValue);
    const displayName = selectedOption ? selectedOption.name : optionValue;

    return (
      <Chip
        sx={{
          mt: 0.5,
          height: "auto",
          maxWidth: "100%",
          "& .MuiChip-label": {
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: 1.3,
            paddingTop: "4px",
            paddingBottom: "4px"
          }
        }}
        label={displayName}
      />
    );

  };

  if (isReadOnly) {
    return (
      <Box className={classes.box}>
        <Typography className={classes.label}>{label}</Typography>
        <CustomFormControl fullWidth variant="outlined" size="small">
          <Box
            sx={{
              minHeight: '40px',
              display: 'flex',
              alignItems: 'center',
              padding: '8px 14px',
              border: '1px solid #e5e7eb',
              borderRadius: '4px',
              backgroundColor: '#f8fafc',
              pointerEvents: 'none',
            }}
          >
            {renderReadOnlyValue()}
          </Box>
        </CustomFormControl>
      </Box>
    );
  }

  return (
    <Box className={classes.box}>
      <Typography className={classes.label}>{label}</Typography>
      <CustomFormControl fullWidth variant="outlined" size="small">
        {loading && <LinearProgress className={classes.progress} />}
        <NativeSelect
          input={<OutlinedInput notched />}
          inputProps={{
            name: label,
          }}
          value={optionValue}
          defaultValue=""
          ref={ref}
          disabled={disabled}
          onChange={(e) => {
            if (e.target.value === "") return;
            onChange(e);
            setValue(e.target.value);
          }}
          {...props}
        >
          <option
            value=""
            className={classes.placeholder}
            disabled
            selected
            key="placeholder"
          >
            {placeholder}
          </option>
          {options.length > 0 &&
            options.map((option) => {
              return (
                <option key={option.value} value={option.value}>
                  {CustomOption ? <CustomOption {...option} /> : option.name}
                </option>
              );
            })}
        </NativeSelect>
      </CustomFormControl>
    </Box>
  );
});

export default MUINativeSelect;
